import React, { useState } from 'react';

const SELF_HOST_URL = process.env.REACT_APP_SELF_URL || '';

export default function () {
  const [isReloading, setReloading] = useState(false);

  async function get() {
    setReloading(true);

    try {
      // TODO: add authentication to this request
      await fetch(`${SELF_HOST_URL}/.netlify/functions/reload`, {
        method: 'POST',
      });
    } catch (err) {
      setReloading(false);
      alert(err);
      return;
    }

    setReloading(false);
    alert(
      'Successfully reloaded data in Azure. Refresh the page to see the new data in the dashboard'
    );
  }

  return (
    <button onClick={get} disabled={isReloading}>
      Reload from Google Sheets
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/components/reload/reload.jsx